import { MEDIA_URL } from '@/constants/env';
import { slideInLeft, slideInRight } from '@/constants/motions';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';
import Link from 'next/link';
import Markdown from 'react-markdown';

export default function OurCompaniesBlock({ data }) {
  const safe = data || {};
  const imageUrl = safe?.image?.data?.attributes?.url || '';
  return (
    <section className="relative px-4 py-16 lg:mt-32 lg:py-0">
      <div className="absolute inset-0 w-full bg-primary-20 lg:h-[640px] lg:skew-y-6"></div>
      <div className="container-screen relative">
        <div className="grid items-center gap-8 overflow-hidden md:grid-cols-2 xl:overflow-visible">
          <motion.div
            className="order-2 md:order-1"
            initial="hidden"
            transition={slideInLeft.transition}
            variants={slideInLeft}
            viewport={slideInLeft.viewport}
            whileInView="visible"
          >
            <h2 className="text-4xl font-medium text-primary-600">{safe.title}</h2>
            <article className="prose mt-6 prose-a:uppercase prose-a:text-primary-500 prose-a:underline-offset-2 focus-visible:prose-a:outline-dashed focus-visible:prose-a:outline-offset-2 focus-visible:prose-a:outline-primary-200 prose-strong:font-medium">
              <p>
                <strong>{safe.description}</strong>
              </p>
              {/* <p>
                <strong>CEAD Engineering N.V.</strong> is a multidisciplinary engineering company
                that provides engineering services to clients active in energy, water, oil &amp; gas
                and (petro) chemical markets.
                <br />
                <Link href="/companies/engineering">
                  <a>Read More</a>
                </Link>
              </p>
              <p>
                <strong>CEAD Manpower N.V.</strong> is a Surinamese local oilfield service provider
                and local oil &amp; gas recruitment agency for companies working in the industry
                with technical areas.
                <br />
                <Link href="/companies/manpower">
                  <a>Read More</a>
                </Link>
              </p>
              
              <p>
                <strong>CEAD Construction N.V.</strong> is a construction company focusing on the
                development, construction and management of mechanical, civil and electrical
                projects.
                <br />
                <Link href="/companies/construction">
                  <a>Read More</a>
                </Link>
              </p> */}
              {(safe.companies || []).map(({ text, url }, i) => (
                <p key={i}>
                  <Markdown>{text}</Markdown>
                  <Link href={url}>
                    <a>Read More</a>
                  </Link>
                </p>
              ))}
            </article>
          </motion.div>
          <motion.div
            className="order-1 md:order-2"
            initial="hidden"
            transition={slideInRight.transition}
            variants={slideInRight}
            viewport={slideInRight.viewport}
            whileInView="visible"
          >
            {imageUrl ? (
              <Image
                alt="Our companies"
                className="h-80 w-full overflow-hidden rounded-xl object-cover shadow-lg md:h-[480px]"
                src={MEDIA_URL.concat(imageUrl)}
              />
            ) : null}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
